import { FormattedMessage, FormattedNumber } from 'react-intl';

import { AccountOfferingBalance } from '@arrived/models';

import { CellBodyTypography, CellBodyTypographyProps } from '../CellBodyTypography';

export interface RentalIncomePercentMetricProps extends CellBodyTypographyProps {
  latestDividend: AccountOfferingBalance['rentalIncome']['latestDividend'];
  value: number;
}

export const RentalIncomePercentMetric = ({ value, latestDividend, ...rest }: RentalIncomePercentMetricProps) => {
  return (
    <CellBodyTypography
      color={({ palette }) => (latestDividend === null ? palette.neutrals.gray : palette.primary.main)}
      {...rest}
    >
      {latestDividend === null ? (
        <FormattedMessage id="first-dividend-date" defaultMessage="First Dividend" />
      ) : (
        <FormattedMessage
          id="percent-per-year"
          defaultMessage="{percent} / Year"
          values={{
            percent: (
              <FormattedNumber
                style="percent"
                value={(value ?? 0) / 100}
                maximumFractionDigits={1}
                minimumFractionDigits={1}
              />
            ),
          }}
        />
      )}
    </CellBodyTypography>
  );
};
